/**
 * @generated SignedSource<<c841f3747e763ca27b2b479c186917f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SuggestedActions_viewer$data = {
  readonly account: {
    readonly allowMeetingRecording: boolean;
    readonly allowPublicRecap: boolean;
  };
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"LiveReactions_viewer">;
  readonly " $fragmentType": "SuggestedActions_viewer";
};
export type SuggestedActions_viewer$key = {
  readonly " $data"?: SuggestedActions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SuggestedActions_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SuggestedActions_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowMeetingRecording",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowPublicRecap",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LiveReactions_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6aa1d45fcca617f7286e4bea49c04de9";

export default node;
